
<template>
  <v-container>
    <v-footer :padless="true" :app="true">
      <v-card flat tile width="100%" class="text-center" color="footer">
        <v-card-text class="basic--text">
          <v-row justify="center">
            <v-col cols="3" class="text-right">
              {{ new Date().getFullYear() }} — <strong>ProductsDB</strong>
            </v-col>
            <v-col cols="3" class="text-left basic_secondary--text"> V3 </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  name: "Footer",
  data: () => ({}),
  methods: {},
};
</script>